import { createApp } from 'vue'
import App from './App.vue'
import '@/assets/css/output.css';
import '@/assets/libs/@iconscout/unicons/css/line.css';
import '@/assets/libs/@mdi/font/css/materialdesignicons.min.css';
import  '@/assets/libs/animate.css/animate.min.css';
import VueDatePicker from '@vuepic/vue-datepicker';
import VueSmoothScroll from 'vue3-smooth-scroll'
import '@vuepic/vue-datepicker/dist/main.css';
import router from './router' 




const GA_ID = process.env.VUE_APP_GA_ID;

function loadGtag(id) {
  if (!id) return;
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;

  // Load GA script
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(s);

  // Init GA
  gtag("js", new Date());
  gtag("config", id, { send_page_view: false }); 
}


loadGtag(GA_ID);

const app = createApp(App)
app.use(VueDatePicker)
app.use(VueSmoothScroll)
app.use(router)

// Page view tracking
router.isReady().then(() => {
  const gtag = window.gtag;

  // First load
  if (gtag && GA_ID) {
    gtag("event", "page_view", {
      page_title: document.title,
      page_path: router.currentRoute.value.fullPath,
      page_location: window.location.href,
      send_to: GA_ID,
    });
  }

  // On route change
  router.afterEach((to) => {
    if (!gtag || !GA_ID) return;
    gtag("event", "page_view", {
      page_title: to.meta?.title || document.title,
      page_path: to.fullPath,
      page_location: window.location.href,
      send_to: GA_ID,
    });
  });
});
app.mount('#app')
